var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DeveloperCategory, DeveloperFunction } from '@devmod/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { environment } from '../environments/environment';
import * as actions from './store/actions/index';
import * as selectors from './store/reducers/index';
/**
 * This class represents the main application component.
 */
var AppComponent = /** @class */ (function () {
    function AppComponent(store, router) {
        this.store = store;
        this.router = router;
        this.loggedIn = this.store.select(selectors.auth.getLoggedIn);
        this.user = this.store.select(selectors.auth.getLoggedInUser);
        this.currentOrganisation = this.store.select(selectors.getSelected(selectors.ORGANISATIONS));
        this.organisations = this.store.select(selectors.org.getSelectable);
        this.admin = this.store.select(selectors.auth.isAdmin);
        this.appLink$ = this.store
            .select(selectors.auth.getAuthLinkQueryParams)
            .pipe(map(function (params) { return environment.APP_BASE_URL + "/?" + params; }));
        console.log('Environment config', environment);
    }
    AppComponent.prototype.ngOnInit = function () {
    };
    AppComponent.prototype.logout = function () {
        this.store.dispatch(new actions.RequestAuthLogoutAction());
    };
    AppComponent.prototype.systemBrowser = function () {
        this.router.navigate(['/', 'system']);
    };
    AppComponent.prototype.organisationSelected = function (id) {
        this.store.dispatch(actions.Organisations.SelectByIdAction({ id: id }));
    };
    AppComponent.prototype.profile = function () {
        this.store.dispatch(actions.NavigateAction({ path: ['profile'] }));
    };
    __decorate([
        DeveloperFunction(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AppComponent.prototype, "logout", null);
    __decorate([
        DeveloperFunction(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AppComponent.prototype, "systemBrowser", null);
    AppComponent = __decorate([
        DeveloperCategory({
            name: 'Global',
            sort: -1
        }),
        __metadata("design:paramtypes", [Store, Router])
    ], AppComponent);
    return AppComponent;
}());
export { AppComponent };
